import React from "react";
import cn from "classnames";
import { ListLinks } from "~components";
import * as styles from "./styles.module.scss";

const MobileMenu = ({
  primaryColor,
  hasPassedScrollMargin,
  bannerHeight,
  headerHeight,
  scrollY,
  isMobileMenuOpen,
  bannerText,
  menu,
  isTransparencyEnabled
}) => (
  <nav
    style={{
      background: primaryColor,
      height:
        hasPassedScrollMargin && isTransparencyEnabled
          ? `calc(var(--viewport-height) - ${
              bannerHeight - scrollY
            }px - ${headerHeight}px)`
          : `calc(var(--viewport-height) - ${headerHeight}px)`,
      top:
        hasPassedScrollMargin && isTransparencyEnabled
          ? `${headerHeight + bannerHeight - scrollY}px`
          : `${headerHeight}px`
    }}
    className={cn(styles.mobileMenu, {
      [styles.isOpen]: isMobileMenuOpen,
      [styles.hasBanner]: bannerText
    })}
  >
    <ul className="d2">
      <ListLinks links={menu?.links} />
    </ul>
  </nav>
);

export default MobileMenu;
